import { Box, Flex } from '@mantine/core'

import {
  type CategorizedAssetsProps,
  CategorizedAssetsType,
} from '@/components/@Shared/CategorizedAssets/CategorizedAssets.types'
import { CategorizedAssetsItems } from '@/components/@Shared/CategorizedAssetsItem/CategorizedAssetsItem'
import { TYPE_GROUP } from '@/components/@Shared/DonutChart/DonutChart.config'
import { isTypeGroupKey } from '@/components/@Shared/DonutChart/DonutChart.types'
import { Title } from '@/components/Title/Title'

import classes from './CategorizedAssets.module.css'

export function CategorizedAssets({ data, type }: CategorizedAssetsProps) {
  return (
    <Box mt={32}>
      <Title variant="h3">
        My {type === CategorizedAssetsType.ASSETS ? 'assets' : 'debt'}
      </Title>

      <Flex className={classes.container}>
        {data.map(item => {
          if (isTypeGroupKey(item.name)) {
            return (
              <CategorizedAssetsItems
                accounts={item.accounts}
                icon={TYPE_GROUP[item.name].icon}
                name={TYPE_GROUP[item.name].label}
                total={item.value}
              />
            )
          }

          return null
        })}
      </Flex>
    </Box>
  )
}
